import { Injector } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { State } from '@cemex/cmx-client-layout';
import { Store } from '@ngrx/store';
import { isObservable, Observable, of, Subject } from 'rxjs';
import { FieldConfig } from '../modules/configurable-form/models/field-configs/field-config.interface';

export abstract class BaseAsyncValue<T> {
  constructor(
    protected readonly store: Store<State>,
    protected readonly form: UntypedFormGroup,
    protected readonly injector: Injector,
    protected readonly mapItem: any,
    protected readonly ngDestroy: Subject<any>,
    protected readonly config: FieldConfig,
  ) {}
  abstract getValue(...args: any[]): Observable<T>;
}

// typeof BaseAsyncValue: when its defined inside config.ts before runtime
// BaseAsyncValue<T>: after its resolved in runtime
export type AsyncValue<T> = BaseAsyncValue<T> | typeof BaseAsyncValue;

export const isAsyncValueProviderType = (value: any): value is BaseAsyncValue<any> => {
  try {
    return new value() instanceof BaseAsyncValue;
  } catch {
    return value instanceof BaseAsyncValue;
  }
};

export const isAsyncValueProvider = (value: any): value is BaseAsyncValue<any> => {
  return value instanceof BaseAsyncValue;
};

export const getObservableFromAsyncValue = (provider: BaseAsyncValue<any> | Observable<any>) => {
  if (isObservable(provider)) {
    return provider;
  }

  if (isAsyncValueProvider(provider)) {
    return provider.getValue();
  }

  throw Error('Argument should be typeof BaseAsyncValue or Observable, type ' + typeof provider + ' given.');
};

export const getObservableFromAsyncValueSafe = (value): Observable<any> => {
  try {
    return getObservableFromAsyncValue(value);
  } catch (e) {
    return of(value);
  }
};
